// extracted by mini-css-extract-plugin
export default {"container":"Psbutq+tDUgAKhvy7Z-a5w==","picture":"vAJ61sP3qQU+EwikwEZaVw==","text":"CCHq+xvdSrF0EfUlgSzuIw==","link":"_7VMCaupP9GOdH2eARnvl9w=="};